import {
    SAVE_PARAMS_SUPPLY_REQUEST,
    SAVE_PARAMS_SUPPLY_REQUEST_ERROR,
    SAVE_PARAMS_SUPPLY_REQUEST_SUCCESS,
    FETCH_PARAMS_SUPPLY_REQUEST,
    FETCH_PARAMS_SUPPLY_REQUEST_SUCCESS,
    FETCH_PARAMS_SUPPLY_REQUEST_ERROR,
    FETCH_SECTIONS_DEFAULT
  } from 'actionTypes'
  
  const DEFAULT_STATE = {
    get: {
      record: {},
      error: null,
      isFetching: false,
    },
    save: {
      isUpdating: false,
      error: null,
    },
  }
  
  const record = (state = DEFAULT_STATE, action) => {
  
    switch (action.type) {
      case FETCH_SECTIONS_DEFAULT:
        return DEFAULT_STATE
      case FETCH_PARAMS_SUPPLY_REQUEST:
        return {
          ...state,
          isFetching: true,
          error: null,
        }
  
      
      case FETCH_PARAMS_SUPPLY_REQUEST_SUCCESS:
        return {
          ...state,
          get: {
            ...state.get,
            record: action.payload,
            isFetching: false,
            error: null,
          },
        }
  
      case FETCH_PARAMS_SUPPLY_REQUEST_ERROR:
        return {
          ...state,
          get: {
            ...state.get,
            record: {},
            isFetching: false,
            error: action.payload,
          },
        }
  
      case SAVE_PARAMS_SUPPLY_REQUEST:
        return {
          ...state,
          save: {
            ...state.save,
            isUpdating: true,
          },
        }
  
      case SAVE_PARAMS_SUPPLY_REQUEST_SUCCESS:
        return {
          ...state,
          save: {
            ...state.save,
            isUpdating: false,
            error: null,
            success: true,
          },
          get: {
            ...state.get,
            record: {
              ...state.get.record,
              ...action.payload,
            },
          },
        }
  
      case SAVE_PARAMS_SUPPLY_REQUEST_ERROR:
        return {
          ...state,
          save: {
            ...state.save,
            isUpdating: false,
            error: action.payload.error,
          },
        }
      default:
        return state
    }
  }
  
  export default record
  